import { Map } from 'immutable';


import { appActions } from './actions'


export const initialState = new Map({
  show_menu: false,
});

export function appReducer(state = initialState, action){
    const {payload, type} = action

    switch (type) {
        case appActions.INIT_APP:
            return state;
        case appActions.TOGGLE_MENU:
            return state.set('show_menu', !state.get('show_menu'))
        default:
            return state;
    }
}
